module.exports = __webpack_public_path__ + "img/11_32.df6bc3f6.png";